import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormSetupComponent } from "../../../shared/component/form-setup/form-setup.component";
import { ActivatedRoute } from '@angular/router';
import { ApiCallsService } from '../../../shared/services/api-calls.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ScrollingModule } from "@angular/cdk/scrolling";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../shared/services/toast.service';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { ReceiptPrintService } from '../../../shared/services/receipt-print.service';
import Swal from 'sweetalert2';

interface Location {
  id: string;
  location_no: string;
}
@Component({
  selector: 'app-recharge',
  imports: [FormSetupComponent, CommonModule, FormsModule, ScrollingModule, NgbModule],
  templateUrl: './recharge.component.html',
  styleUrl: './recharge.component.scss'
})
export class RechargeComponent implements OnInit, OnDestroy {
  siteid: string | null;
  locationid: string | null;
  preselectedLocation: any = localStorage.getItem('offline_Location')
  constructor(
    private route: ActivatedRoute,
    private apiservice: ApiCallsService,
    private toast: ToastService,
    private receiptPrintService: ReceiptPrintService
  ) {

  }
  ngOnDestroy(): void {
    localStorage.removeItem('offline_Location')
  }
  ngOnInit(): void {
    const siteid = this.route.snapshot.queryParamMap.get('siteid') || localStorage.getItem('site_idLogin');
    this.siteid = siteid ? atob(siteid) : null;

    // Read location id from query param (passed from consumer-detail redirect)
    const locationIdParam = this.route.snapshot.queryParamMap.get('id');
    if (locationIdParam) {
      this.preselectedLocation = atob(locationIdParam);
      this.fromQueryParam = true;
      localStorage.setItem('offline_Location', this.preselectedLocation);
    }

    this.getLocationList(this.siteid)
  }
  showform: boolean = false;
  fromQueryParam: boolean = false;

  formConfig: any = [];
  isFormValid: boolean = false;

  callForForm: boolean;

  /** Resets UI state and, if the location came from a query param, re-selects it automatically */
  private resetAndReload(): void {
    this.showform = false;
    this.formConfig = [];
    this.locationSearchTerm = '';
    this.isFormValid = false;

    if (this.fromQueryParam && this.preselectedLocation) {
      // Re-find the location from the existing list and reopen the form
      const matched = this.selectedLocationIds.find(
        (x: any) => x.id == this.preselectedLocation
      );
      if (matched) {
        this.selectedLocation = matched;
        this.onlocationSelect(matched);
      } else {
        // List may have been wiped — reload it from the API
        this.selectedLocation = null;
        this.getLocationList(this.siteid);
      }
    } else {
      this.selectedLocation = null;
    }
  }
  submitform($event: { id: string; value: any; }) {
    let payload = { ...$event.value };
    delete payload.id;
    payload = { ...payload, site_id: this.siteid, location_id: this.locationid };

    const numberRegex = /^[0-9]+$/;
    let couponAmtStr = String(payload.coupon_amount ?? '').trim();
    let deductionAmtStr = String(payload.deduction_amount ?? '').trim();

    if (!couponAmtStr) {
      for (const key of Object.keys(payload)) {
        if (key.toLowerCase().includes('coupon')) {
          couponAmtStr = String(payload[key] ?? '').trim();
          break;
        }
      }
    }
    if (!deductionAmtStr) {
      for (const key of Object.keys(payload)) {
        if (key.toLowerCase().includes('deduction')) {
          deductionAmtStr = String(payload[key] ?? '').trim();
          break;
        }
      }
    }

    if (!couponAmtStr) {
      this.toast.showToast('Coupon Amount is required', 'colored', 5000, 'warning');
      return;
    }

    if (!numberRegex.test(couponAmtStr)) {
      this.toast.showToast('Special characters are not allowed in Coupon Amount. Only numbers are allowed', 'colored', 5000, 'warning');
      return;
    }
    if (deductionAmtStr && !numberRegex.test(deductionAmtStr)) {
      this.toast.showToast('Special characters are not allowed in Deduction Amount. Only numbers are allowed', 'colored', 5000, 'warning');
      return;
    }

    if (Number(payload.coupon_amount) < 0 || Number(payload.deduction_amount) < 0) {
      this.toast.showToast('Amount cannot be negative', 'colored', 5000, 'warning');
      return;
    }

    if (Number(payload.coupon_amount) < Number(payload.deduction_amount)) {
      this.toast.showToast('Deduction Amount cannot be greater than coupon amount', 'colored', 5000, 'warning');
      return;
    }
    if (Number(payload.coupon_amount) === Number(payload.deduction_amount)) {
      this.toast.showToast('Deduction Amount cannot be equal to coupon amount', 'colored', 5000, 'warning');
      return;
    }

    // Ensure coupon_amount and deduction_amount are in string format
    payload.coupon_amount = couponAmtStr;
    payload.deduction_amount = deductionAmtStr;

    this.apiservice.SendOfflineRecharge(payload).subscribe({
      next: (res) => {
        if (!this.handleApiResponse(res)) return;
        if (payload.print_receipt === 'Yes' || payload.print_receipt === 'Y') {
          this.printReciept(res.Data);
        } else {
          Swal.fire({
            title: 'Recharge Successful',
            icon: 'success',
            confirmButtonText: 'Close'
          });
          this.resetAndReload();
        }
      },
      error: (err) => {
        this.toast.showToast(
          err?.error?.Message || 'Recharge failed',
          'colored',
          5000,
          'danger'
        );
      }
    });
  }
  formSubmit($event: boolean) {
    this.isFormValid = $event;
  }
  handleApiResponse(res: any, errorMsg: string = '') {
    if (res?.Status === 'Error') {
      this.toast.showToast(res?.Message || errorMsg, 'colored', 5000, 'danger');
      return false;
    }
    return true;
  }
  getLocationList(siteid: string | null = '') {
    const site_id = siteid
    if (site_id) {
      this.apiservice.getLocationList(site_id).subscribe({
        next: (res) => {
          if (!this.handleApiResponse(res)) return;
          let data = res?.Data || [];

          if (this.preselectedLocation) {

            const matchedLocation = data.find(
              (x: any) => x.id == this.preselectedLocation
            );
            (matchedLocation)
            if (matchedLocation) {
              this.selectedLocation = matchedLocation;
              this.onlocationSelect(matchedLocation);
            }
          }
          this.selectedLocationIds = data;
        },
        error: (err) => {
          this.toast.showToast(
            err?.error?.message || 'Failed to fetch location list',
            'colored',
            5000,
            'warning'
          );
        }
      });
    }
  }
  get filteredLocations(): Location[] {
    if (!this.locationSearchTerm) {
      return this.selectedLocationIds;
    }

    const term = this.locationSearchTerm.toLowerCase();
    return this.selectedLocationIds.filter(loc =>
      loc.location_no?.toLowerCase().includes(term)
    );
  }
  locationSearchTerm: string = '';
  selectedLocation: Location | null = null;
  selectedLocationIds: Location[] = [];
  getrechargeform(location: any) {
    this.locationid = location.id
    this.apiservice.getRechargeForm().subscribe({
      next: (res) => {
        if (!this.handleApiResponse(res)) return;

        this.formConfig = res.Data.list;

        if (!this.formConfig || !Array.isArray(this.formConfig)) {
          return;
        }

        const isCouponField = (field: any) => {
          const id = String(field.id || '').toLowerCase();
          const header = String(field.header || '').toLowerCase();
          return id === 'coupon_amount' || id.includes('coupon') || header.includes('coupon');
        };

        const isDeductionField = (field: any) => {
          const id = String(field.id || '').toLowerCase();
          const header = String(field.header || '').toLowerCase();
          return id === 'deduction_amount' || id.includes('deduction') || header.includes('deduction');
        };

        const applyFieldConfig = (items: any[]) => {
          if (!items) return;
          items.forEach((field: any) => {
            if (field.id && location[field.id] !== undefined) {
              field.existingValue = location[field.id];
            }

            if (field.id === 'recharge_also' || field.id === 'print_receipt') {
              field.existingValue = 'Y';
            }
            if (isDeductionField(field)) {
              field.existingValue = field.existingValue ?? '0';
            }

            // Enforce strict digit-only regex (disallow special characters like - + . , @ etc)
            if (isCouponField(field)) {
              field.pattern = '^[0-9]+(\\.[0-9]+)?$';
              field.regex = '^[0-9]+(\\.[0-9]+)?$';
              field.patternMessage = 'Special characters are not allowed. Only numbers (including decimals) are allowed';
              field.regexMessage = 'Special characters are not allowed. Only numbers (including decimals) are allowed';
              field.keyRequired = true;
              field.required = true;
              field.typeText = 'text';
            }
            if (isDeductionField(field)) {
              field.pattern = '^[0-9]+(\\.[0-9]+)?$';
              field.regex = '^[0-9]+(\\.[0-9]+)?$';
              field.patternMessage = 'Special characters are not allowed. Only numbers (including decimals) are allowed';
              field.regexMessage = 'Special characters are not allowed. Only numbers (including decimals) are allowed';
              field.typeText = 'text';
            }

            if (field.type === 'group' && Array.isArray(field.children)) {
              applyFieldConfig(field.children);
            }
            if (field.type === 'tabs' && Array.isArray(field.tabs)) {
              field.tabs.forEach((tab: any) => applyFieldConfig(tab.children));
            }
          });
        };

        applyFieldConfig(this.formConfig);
        console.log(this.formConfig);


        this.showform = true;
      },

      error: (err) => {
        this.toast.showToast(
          err?.error?.message || 'Failed to load recharge form',
          'colored',
          5000,
          'danger'
        );
      }
    });
  }

  printReciept(data: any) {
    this.receiptPrintService.printSingleReceipt(data, this.siteid);
    Swal.fire({
      title: 'Recharge Successful',
      icon: 'success',
      confirmButtonText: 'Close'
    });
    this.resetAndReload();
  }

  onlocationSelect(location: any) {
    this.showform = false;
    this.isFormValid = false;
    this.selectedLocation = location;
    this.locationSearchTerm = '';
    this.getrechargeform(location);
  }

  triggerSubmit() {
    if (!this.isFormValid) {
      this.toast.showToast('Please fill all required fields before recharging', 'colored', 4000, 'warning');
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to recharge?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Recharge',
      cancelButtonText: 'No',
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#d33'
    }).then((result) => {
      if (result.isConfirmed) {
        this.callForForm = true;

        setTimeout(() => {
          this.callForForm = false;
        }, 0);
      }
    });
  }
}
